var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(savedReply){return _c('div',{key:savedReply.id},[_c('div',{class:{
        'hover:bg-gray-50': savedReply.id !== _vm.savedReplyId,
        'border-l-2 border-blue-700 bg-indigo-50 hover:bg-indigo-100':
          savedReply.id === _vm.savedReplyId,
      }},[_c('div',{staticClass:"cursor-pointer border-b border-gray-100",style:({ paddingLeft: `${(savedReply.depth + 1) * 20}px` })},[_c('list-item',{attrs:{"savedReply":savedReply}})],1)]),(!savedReply.leaf)?_c('saved-reply-tree',{attrs:{"list":savedReply.children,"savedReplyId":_vm.savedReplyId}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }